import { render, staticRenderFns } from "./recommanderDetailList.vue?vue&type=template&id=448bd9a2&scoped=true"
import script from "./recommanderDetailList.vue?vue&type=script&lang=ts"
export * from "./recommanderDetailList.vue?vue&type=script&lang=ts"
import style0 from "./recommanderDetailList.vue?vue&type=style&index=0&id=448bd9a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448bd9a2",
  null
  
)

export default component.exports